export default __webpack_public_path__ + "static/media/icn-arrow-horizontal.df1de2fb.svg";